var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationEmptyStateChallenges(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #212529;\n      }\n\n      .cls-3 {\n        fill: #7e0386;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #eef0f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    "data-name": "Elipse 1365",
    className: "cls-5",
    cx: 48,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.13,71.95l-60.48-7.89c-3.12-.41-5.32-3.23-4.91-6.3l3.89-28.86c.41-3.07,3.28-5.24,6.41-4.83l60.48,7.89c3.12,.41,5.32,3.23,4.91,6.3l-3.89,28.86c-.41,3.07-3.28,5.24-6.41,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.88,72.5c-.27,0-.54-.02-.82-.05l-60.48-7.89c-1.66-.22-3.13-1.06-4.14-2.38-.99-1.29-1.42-2.89-1.2-4.49l3.89-28.86c.45-3.34,3.57-5.69,6.96-5.26l60.48,7.89c1.66,.22,3.13,1.06,4.14,2.38,.99,1.29,1.42,2.89,1.2,4.49l-3.89,28.86c-.41,3.07-3.09,5.31-6.15,5.31Zm-.69-1.04c2.86,.37,5.47-1.6,5.85-4.4l3.89-28.86c.18-1.34-.18-2.67-1-3.75-.85-1.1-2.08-1.81-3.47-1.99l-60.48-7.89c-2.85-.37-5.47,1.6-5.85,4.4l-3.89,28.86c-.18,1.34,.18,2.67,1,3.75,.85,1.1,2.08,1.81,3.47,1.99l60.48,7.89Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 63.23,
    y: 25.38,
    width: 1,
    height: 29.33,
    transform: "translate(15.78 98.06) rotate(-82.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.46,
    y: 37.1,
    width: 1,
    height: 17.46,
    transform: "translate(4.15 96.38) rotate(-82.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.63,61.8l-19.74-2.58c-1.4-.18-2.39-1.45-2.2-2.83l3.32-24.65c.19-1.38,1.47-2.35,2.88-2.17l19.74,2.58c1.4,.18,2.39,1.45,2.2,2.83l-3.32,24.65c-.19,1.38-1.47,2.35-2.88,2.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.85 50.71 30.11 45.5 24.55 49.21 24 48.38 30.36 44.13 34.66 50.12 33.85 50.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.32,45.2c-.12,0-.24,0-.36-.02-.73-.1-1.38-.47-1.82-1.05-.44-.57-.62-1.28-.53-1.98,.2-1.48,1.58-2.51,3.07-2.32,.73,.1,1.38,.47,1.82,1.05,.44,.57,.62,1.28,.53,1.98-.18,1.35-1.36,2.34-2.71,2.34Zm0-4.4c-.86,0-1.6,.62-1.72,1.48-.06,.44,.06,.89,.33,1.24,.28,.37,.69,.6,1.16,.66,.96,.13,1.82-.53,1.95-1.46h0c.06-.44-.06-.88-.33-1.24-.28-.37-.69-.6-1.16-.67-.08-.01-.16-.02-.23-.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.44,61.95l-17.22-2.25c-.51-.07-.87-.53-.8-1.03l.42-3.1c.07-.5,.54-.85,1.05-.79l17.22,2.25c.51,.07,.87,.53,.8,1.03l-.42,3.1c-.07,.5-.54,.85-1.05,.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.56,62.45c-.06,0-.12,0-.19-.01l-17.22-2.25c-.38-.05-.72-.25-.95-.55-.23-.3-.33-.67-.28-1.04l.42-3.1c.1-.77,.81-1.32,1.61-1.22l17.22,2.25c.38,.05,.72,.25,.95,.55,.23,.3,.33,.67,.28,1.04l-.42,3.1c-.09,.71-.71,1.23-1.42,1.23Zm-.06-1c.24,.04,.46-.13,.49-.36l.42-3.1c.01-.11-.01-.21-.08-.3-.07-.09-.17-.15-.29-.17l-17.22-2.25c-.24-.03-.46,.13-.49,.36l-.42,3.1c-.01,.11,.01,.21,.08,.3,.07,.09,.17,.15,.29,.17l17.22,2.25Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStateChallenges);
export default __webpack_public_path__ + "static/media/illustration_empty-state-challenges.464ab92f0d00e3f3fc6e05159b589fee.svg";
export { ForwardRef as ReactComponent };